export default "<!--\n  TODO: use user's email with mailchimp\n-->\n\n<div class=\"container\">\n  <p>newsletter works!</p>\n</div>\n"